import { template } from './template/template';

export const environment = {
  production: true,
  debug: false,
  useGo: false,
  lite: true,
  template: template,
  apiUrl: 'https://api.classic.valueminer.eu',
  messagingUrl: 'https://classic.valueminer.eu/messaging',
  messagingSocketNamespace: 'https://classic.valueminer.eu',
  messagingSocketPath: '/socket.io',
  exportUrl: 'https://export.classic.valueminer.eu',
  oauthUrl: 'https://oauth.classic.valueminer.eu',
  imageUrl: 'https://oauth.classic.valueminer.eu/profile/?id=',
  fileupload: 'https://oauth.classic.valueminer.eu',
  go: 'https://apigo.classic.valueminer.eu',
  s3: 'valueminer.local',
  aws: {
    access_key_id: 'AKIAVQ3RHJYALBWTHAN4',
    access_key_secret: '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',
    s3_bucket: 'valueminer.local',
    s3_region: 'eu-central-1',
  },
  auth: {
    authurl: 'https://oauth.classic.valueminer.eu/oauth/authorize/',
    tokenurl: 'https://oauth.classic.valueminer.eu/oauth/token/',
    logouturl: 'https://oauth.classic.valueminer.eu/wp-login.php?action=logout',
    clientID: 'valueminer',
    redirectURL: 'https://classic.valueminer.eu/',
    scopes: ['api', 'users']
  },
  socket: {
    url: 'https://apigo.classic.valueminer.eu',
    path: '/socket.io/'
  }
};
